import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { ssApiService } from '../../services/ss-api.service';
import { BaseResponse, IBaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { CreditCardArray } from '../../models/domain/credit.card';
import { SelectItem } from 'primeng/primeng';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { GISAddonPayMember, GISAddons, LicenseBasic, LicenseBasicArray } from '../../models/domain/gis.product.item';
import { GISAddonProductBasicArray, GISAddonProductBasic } from '../../models/domain/gis.product.item';
import { GisAddonPurchaseRequest } from '../../models/ss-api/requests/gis.addon.purchase.request';
import { Router } from '@angular/router';
import { state } from '@angular/animations';

export interface IAddGISDialogModel {
    title: string;
    subTitle: string;
    message: string;
    MemberID: number;
}

@Component({
    selector: 'add-gis-dialog',
    styleUrls: ['./add.gis.dialog.css'],
    templateUrl: './add.gis.dialog.html'
})
export class AddGISDialog extends DialogComponent<IAddGISDialogModel, boolean> implements IAddGISDialogModel, OnInit {

    IsBusy: boolean = false;

    title: string;
    subTitle: string;
    message: string;

    MemberID: number;
    LicenseKeys: LicenseBasicArray;
    SelectedLicenseKey: LicenseBasic;
    IsDesigner: boolean;

    // CREDIT CARD VARIABLES
    CCData: CreditCardArray;

    creditCards: SelectItem[] = [];
    selectedCreditCard: number;

    chargeForCredits: boolean = true;

    // GIS PACKAGE VARIABLES
    LicenseKeyOptions: SelectItem[] = [];
    GISPackageOptions: SelectItem[] = [];
    MemberPay: GISAddonPayMember = new GISAddonPayMember();

    
    GISResponse: GISAddons = new GISAddons();
    GISProducts: GISAddonProductBasicArray = new GISAddonProductBasicArray();
    SelectedGISAddon: GISAddonProductBasic = new GISAddonProductBasic();

    SelectedPackageID: number;
    SelectedLicenseID: number;

    State: string;
    TaxRateDisplay: string;
    TotalPrice: number;
    TaxAmount: number;
    ProductPrice: number;



    // CONSTRUCTOR
    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public router: Router) {
        super(dialogService, router);
    }

    // ONINIT
    ngOnInit() {
        this.setUpCreditCards();
        this.setUpProducts();
    }

    setUpProducts() {

        console.log("Selected License Key", this.SelectedLicenseKey);

        this.api.GetGISAddonProducts(this.MemberID).toPromise().then(result => {
            console.log("GIS Addon Products", result.Data);            
            result.Data.Products.forEach(x => 
                {
                        this.GISPackageOptions.push({ label: x.Name, value: x.ID });
                }
            );

            result.Data.Licenses.forEach(x => 
                {
                    var licenseLabel =  x.LicenseKey + " - " + x.MemberFullName;
                    if (x.HasSubscription)
                        licenseLabel += " - has subscription";

                    this.LicenseKeyOptions.push({ label: licenseLabel, value: x.LicenseID });
                }
            );

            this.GISProducts = result.Data.Products;
            this.GISResponse = result.Data;
            this.LicenseKeys = result.Data.Licenses;
            this.MemberPay = result.Data.Member;
            this.State = this.MemberPay.State;          
            this.TaxRateDisplay = this.MemberPay.TaxPercent.toString();   

            console.log("preset GIS", this.GISPackageOptions[0].value);
            this.SelectedPackageID = this.GISPackageOptions[0].value;
            this.SelectedLicenseKey  = this.LicenseKeys.find(i => i.LicenseID == this.LicenseKeyOptions[0].value);

            this.SelectedGISAddon =  this.GISProducts[0];
            this.SelectedLicenseID = result.Data.Licenses[0].LicenseID;

            this.TotalPrice = this.GISProducts[0].Total;
            this.TaxAmount = this.GISProducts[0].Tax;
           // this.State = this.GISProducts[0].State;
            this.TaxRateDisplay = this.GISProducts[0].TaxPercent.toString();
        }
        );

    }

    LicenseKeyChanged(e)
    {
        this.SelectLicense(this.SelectedLicenseID);     
        console.log("selected license key", this.SelectedLicenseKey);
    }
    

    GISChanged(e) {
        this.SelectGISAddonPackage(this.SelectedPackageID);      
        console.log("SPID", this.SelectedGISAddon);      

    }

    SelectLicense(licenseID: number)
    {        
        if (this.SelectedLicenseID != licenseID)
            this.SelectedLicenseID = licenseID;

        this.SelectedLicenseKey = this.LicenseKeys.find(i => i.LicenseID == licenseID);   
        this.SelectGISAddonPackage(this.SelectedPackageID);  
    }

    SelectGISAddonPackage(packageID: number)
    {
        if (this.SelectedPackageID != packageID)
            this.SelectedPackageID = packageID;

        this.SelectedGISAddon = this.GISProducts.find(i => i.ID == packageID);
        console.log("preset GIS", this.SelectedGISAddon );

        if (this.SelectedLicenseKey.HasSubscription && this.SelectedGISAddon.SubscriptionDiscountPrice > 0){
            this.TotalPrice =  this.SelectedGISAddon.TotalSubscriptionDiscountPrice;
            this.TaxAmount =  this.SelectedGISAddon.TaxSubscriptionDiscountPrice;
            this.ProductPrice = this.SelectedGISAddon.SubscriptionDiscountPrice;
        }
        else{
            this.TotalPrice =  this.SelectedGISAddon.Total;
            this.TaxAmount =  this.SelectedGISAddon.Tax;
            this.ProductPrice = this.SelectedGISAddon.Price;
        }

        this.TaxRateDisplay =  this.MemberPay.TaxPercent.toString();  
    }

    cardChanged(e) {
        this.selectedCreditCard = e.value;
    }

    // CREDIT CARD METHODS
    async setUpCreditCards() {

        this.IsBusy = true;

        this.creditCards.push({ label: 'FREE Credits - Don\'t Charge Card', value: 0 });

        await this.api.getUsableCCards(this.MemberID).subscribe(
            (result: BaseResponse<CreditCardArray>) => {
                this.CCData = result.Data;

                if (this.CCData != undefined && this.CCData.length > 0) {
                    // Sort the cards so default is always the first option
                    let sortedCreditCards = this.CCData.sort(function (a, b) {
                        return (a.IsDefault === b.IsDefault) ? 0 : a.IsDefault ? -1 : 1;
                    })

                    sortedCreditCards.forEach(e => {

                        if (!e.IsActive || e.IsDeleted || (!e.IsDefault && e.Status == 'Expired'))
                            return;

                        let newCard: SelectItem = {
                            label: e.FirstName + ' ' + e.LastName + ' - XXXX XXXX XXXX ' + e.LastFour, value: e.ID
                        };
                        this.creditCards.push(newCard);
                    });
                } else {
                    this.creditCards.push({ label: 'No Card On Account', value: -1 });
                }

                this.selectedCreditCard = this.creditCards[1].value;
                this.IsBusy = false;
            }, (error: any) => {
                this.IsBusy = false;
            }

        );

    }



    addGIS() {

        this.IsBusy = true;

        let request = new GisAddonPurchaseRequest();
        request.ProductID = this.SelectedPackageID;
        request.CreditCardID = this.selectedCreditCard;
        request.LicenseKey =  this.SelectedLicenseKey.LicenseKey;

        if (this.selectedCreditCard == 0)
            request.IsFree = true;

        this.sweetAlertService.swal(
            {
                title: 'Add GIS Credits?',
                text: 'Are you sure you want to add this credit bundle?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes, add!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.GISAddonPurchase(request).toPromise();
                }
            })
            .then((response: IBaseResponse<string>) => {

                this.result = true;
                this.close();

                if (!response.Result) {
                    // error
                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: 'Process/Payment error: ' + response.Data,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                        })
                        .then((response: any) => {
                            this.result = false;
                            this.IsBusy = false;
                            this.close();
                        }, (dismiss) => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                    return;
                }


                this.sweetAlertService.swal(
                    {
                        title: 'Success!',
                        text: 'Credits Added',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then((response: any) => {
                        this.IsBusy = false;

                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            }, (dismiss) => {
                // this.IsBusy = false;
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.result = false;
                        this.IsBusy = false;
                        this.close();
                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });

    }

    confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }


}
